module.exports = __webpack_public_path__ + "img/advertisement_button.d7b98e19.jpg";